import Ajax from '../common/ajax'
import store from '../store'

export default {
  model: 'user',
  sendVcode (mobile, smsType) {
    return Ajax.post(`/api/gradeEvaluation/v1/user/authcode`, { mobile, smsType })
  },
  loginByVcode (mobile, vcode) {
    let appInfo = store.state.appInfo
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/login`, { mobile: mobile, authCode: vcode, organizationId: appInfo.organizationId })
  },
  getList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/list`, queryParam)
  }
}
